import {Box, SimpleGrid, Spinner, Text} from "@chakra-ui/react";
import {gql, useQuery} from "@apollo/client";
import Card from "components/card/Card"
import {useLocation} from "react-router-dom";
import React, {useState} from "react";
import {getProductsForProductFamilyQuery, processProductFamilyData, VariantSelector} from "../analyze/index";
import SentimentSynchronizer from "./SentimentSynchronizer";


function useLocationQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const productFamilyAspects = gql`
query ProductFamilyAspects($product_family: String = "") {
  text_aspects(distinct_on: aspect, where: {text: {product: {product_family: {_eq: $product_family}}}}) {
    aspect
  }
}
`

export default function Default(props) {
    // TODO: Replace the passing of product ids from locationquery to props
    //const {productA, productB} = props;
    // Assuming that all the query params actually belong to the same product / product family
    let query = useLocationQuery();


    const [currentVariantA, setCurrentVariantA] = useState("All Variants");
    const [currentVariantB, setCurrentVariantB] = useState("All Variants");

    let productFamilyA = query.get('product_family_a');
    let productFamilyB = query.get('product_family_b');
    let {
        loading: loadingFamilyA,
        error: errorFamilyA,
        data: dataFamilyA
    } = useQuery(getProductsForProductFamilyQuery, {variables: {"product_family": productFamilyA}})
    let {
        loading: loadingFamilyB,
        error: errorFamilyB,
        data: dataFamilyB
    } = useQuery(getProductsForProductFamilyQuery, {variables: {"product_family": productFamilyB}})
    let {loading: loadingA, error: errorA, data: dataA} = useQuery(productFamilyAspects,
        {
            variables: {"product_family": productFamilyA}
        });
    let {loading: loadingB, error: errorB, data: dataB} = useQuery(productFamilyAspects,
        {
            variables: {
                "product_family": productFamilyB,
            }
        });
    if (loadingFamilyA || loadingFamilyB || loadingA || loadingB) {
        return <Box pt={{base: "130px", md: "80px", xl: "80px"}}><Spinner/> <Text>Loading...</Text></Box>
    }
    if (errorFamilyA || !dataFamilyA) {
        return (<div>Error, Please refresh to try again {errorFamilyA}</div>);
    }
    if (errorFamilyB || !dataFamilyB) {
        return (<div>Error, Please refresh to try again {errorFamilyB}</div>);
    }
    if (errorA || !dataA) {
        return (<div>Error, Please refresh to try again {errorB}</div>);
    }
    if (errorB || !dataB) {
        return (<div>Error, Please refresh to try again {errorB}</div>);
    }
    let {
        product_variants: product_variantsA,
        variant_to_product_ids: variant_to_product_idsA,
        image: imageA
    } = processProductFamilyData(dataFamilyA);
    //console.log('productA', productA);
    let {
        product_variants: product_variantsB,
        variant_to_product_ids: variant_to_product_idsB,
        image: imageB
    } = processProductFamilyData(dataFamilyB);

    console.log('loading', loadingA);
    if (loadingA || loadingB) return "Loading";
    if (errorA) return `Error! ${errorA.message}`;
    if (errorB) return `Error! ${errorB.message}`;
    console.log('dataA', dataA, loadingA, errorA);

    const aspectsA = dataA.text_aspects.map((x) => (x.aspect));
    const aspectsBSet = new Set(dataB.text_aspects.map((x) => (x.aspect)));

    const commonAspects = aspectsA.filter(x => aspectsBSet.has(x)); // Possible performance optimization.
    console.log('aspectsA', aspectsA.length, 'aspectsB', aspectsBSet.size);
    console.log('commonAspects', commonAspects);


    return (
        <Card w="95%" borderRadius='30px' mt='24px' mx='auto'>
            <SimpleGrid columns={2} pt="30px">

                <VariantSelector image={imageA} product_family={productFamilyA} currentVariant={currentVariantA}
                                 setCurrentVariant={setCurrentVariantA} product_variants={product_variantsA}
                                 dateRangePickerEnabled={false}/>

                <VariantSelector image={imageB} product_family={productFamilyB} currentVariant={currentVariantB}
                                 setCurrentVariant={setCurrentVariantB} product_variants={product_variantsB}
                                 dateRangePickerEnabled={false}/>
                <SentimentSynchronizer product_idsA={variant_to_product_idsA[currentVariantA]}
                                       product_idsB={variant_to_product_idsB[currentVariantB]}
                                       sharedAspects={commonAspects}/>
            </SimpleGrid>
        </Card>
    )
}